import {
    AUTH_LOGIN_URL,
    TOP_CONTRIBUTORS_URL,
    TOP_TAGS_URL,
    ACTIVITY_CALENDAR_URL,
    ALL_LITTERS_URL,
    TAGS_URL,
    USERS_URL,
    REPORTS_URL,
    PIECES_COLLECTED_URL,
    PARTNER_CHALLENGE_NAMES_URL,
    PARTNER_CHALLENGES_URL,
    PARTNER_CHALLENGE_URL,
    PARTNER_CAMPAIGNS_URL,
    SEGMENT_TAGS_URL,
    RECURRING_CHARGE_URL,
    ROLE_UPDATE_TO_PAID_CONTRIBUTOR_URL,
    USER_PERMISSION_URL,
    AUTH_SIGNUP_URL,
    CHALLENGE_URL,
    ML_TAGS_URL,
    USER_SEGMENTS_URL,
    SWITCH_USER_ROLE_URL,
    AUTH_FB_LOGIN_URL,
    ANALYSIS_CHALLENGES_URL,
    ANALYSIS_RESEARCHERS_URL,
    ANALYSIS_SEGMENTS_URL,
    ANALYSIS_SUMMARY_TOP_TAGS_URL,
    ANALYSIS_SEGMENT_TAGS_URL,
    ANALYSIS_HEATMAP_LITTERS_URL,
    ANALYSIS_SEGMENT_INDEX_URL,
    RESOURCES_URL,
    PARTNER_ADMINS_URL,
    PARTNER_CITIZEN_SCIENTIST_URL,
    PARTNER_CHILD_URL,
    BASE_PARTNER_URL_V6,
    AUTH_FORGOTPASSWORD_URL,
    AUTH_RESETPASSWORD_URL,
    PARTNER_LICENSE_URL,
    EMAIL_URL,
    MONITOR_URL,
    GET_PARTNER_CONNECTED_CHALLENGES_URL,
    GET_CHALLENGE_CODES_URL,
    CHANGE_ROLE_URL,
    SEGMENT_IMAGES_URL,
    UPDATE_SEGMENT_URL,
    SEGMENT_LITTERS_URL,
    CHALLENGE_NOTIFICATION_URL,
    NEW_CHALLENGE_CODE_URL,
    GET_CAMPAIGN_CHALLENGES_URL,
    PRICING_URL,
    PARTNER_LIST_URL,
    PARTNER_TOKEN_URL,
    REFRESH_USER_TOKEN_URL,
    RESEARCH_PROJECTS_URL,
    RESEARCH_GET_PLACES_URL,
    // RESEARCH_ADD_PLACE_URL,
    RESEARCH_EDIT_PLACE_URL,
    RESEARCH_ASSIGN_PLACES_URL,
    RESEARCH_PLACE_DETAIL_URL,
    RESEARCH_UNASSIGN_PLACE_URL,
    PARTNER_COUNTRIES_URL,
    PARTICIPATED_CHALLENGES_URL,
    CREATE_LOCAL_CHALLENGE_URL,
    CREATE_GLOBAL_CHALLENGE_URL,
    CREATE_FEATURED_CHALLENGE_URL,
    GET_FEATURED_CHALLENGES_URL,
    SEARCH_CHALLENGES_URL,
    PARTNER_INVITE_URL,
    GET_REPORT_CSV,
    GET_SPECIFIC_LITTER,
    PARTNER_USERS_URL,
    RESEND_PARTNER_INVITE_URL,
    GET_MS4_REPORT,
    UPDATE_CHALLENGE_CODE_URL,
    USER_IMAGES_URL,
    GET_ALL_TAXONOMY_URL,
    UPDATE_TAGS_BY_IMAGE_ID,
    GET_PROJECT_LOCATIONS,
    GET_PROJECT_ZONES,
    GET_LITTERS_FOR_MANY_SEGMENTS,
    UPDATE_RESEARCH_SEGMENT_BY_ID,
    UPDATE_RESEARCH_TASK_BY_ID,
    RESEARCH_PROJECT_BY_ID,
    RESEARCH_LOCATIONS,
    RESEARCH_ANALYZE_IMAGE_BY_ID,
} from './constants';
import { post, get, patch, destroy } from './utils';
import axios from 'axios';

export async function forgotPassword(email) {
    const res = await post(AUTH_FORGOTPASSWORD_URL, { email });
    return res.data.data;
}

export async function getSpecificLitter(id) {
    const res = await get(`${GET_SPECIFIC_LITTER}/${id}`);
    return res.data.data;
}

export async function getCsv(params) {
    return await get(GET_REPORT_CSV, { ...params });
}

export async function getMs4Report(params) {
    return await axios({
        url: GET_MS4_REPORT,
        method: 'GET',
        params,
        responseType: 'blob',
    });
}

export async function resetPassword({ token, password }) {
    return post(AUTH_RESETPASSWORD_URL, { token, password }).then((res) => {
        return res.data.data;
    });
}

export async function login(userCreds) {
    return post(AUTH_LOGIN_URL, userCreds).then((res) => res.data.data);
}

export async function fbLogin(userCreds) {
    return post(AUTH_FB_LOGIN_URL, userCreds).then((res) => res.data.data);
}

export async function register(userCreds) {
    return post(AUTH_SIGNUP_URL, userCreds).then((res) => res.data.data);
}

export async function getPricing() {
    return get(PRICING_URL).then((res) => res.data.data);
}

export async function getPartners(params = {}) {
    const { limit, skip } = params;
    return get(PARTNER_LIST_URL, { limit, skip }).then((res) => res.data.data);
}

export async function getPartnerToken(params = {}) {
    return get(`${PARTNER_TOKEN_URL}${params.partnerId}`).then(
        (res) => res.data.data,
    );
}

export async function getUserToken() {
    return get(REFRESH_USER_TOKEN_URL).then((res) => res.data.data);
}

export async function getTopContributors(params = {}) {
    params = { limit: 20, ...params };
    return get(TOP_CONTRIBUTORS_URL, params).then((res) => res.data.data);
}

export async function getChallengeTopContributors(params = {}) {
    const { challengeId } = params;
    params = { limit: 20, ...params.params };
    return get(
        `${PARTNER_CHALLENGE_URL}/${challengeId}/top-contributors`,
        params,
    ).then((res) => res.data.data);
}

export async function getTopTags(params = {}) {
    params = { limit: 10, ...params };
    return get(TOP_TAGS_URL, params).then((res) => res.data.data);
}

export async function getMLTags(params = {}) {
    params = { limit: 10, ...params };
    return get(ML_TAGS_URL, params).then((res) => res.data.data);
}

export async function getChallengeTopTags(params = {}) {
    const { challengeId } = params;
    params = { limit: 10, ...params.params };
    return get(`${PARTNER_CHALLENGE_URL}/${challengeId}/top-tags`, params).then(
        (res) => res.data.data,
    );
}

export async function getActivityCalendar(params = {}) {
    return get(ACTIVITY_CALENDAR_URL, params).then((res) => res.data.data);
}

// Duplicates getPartnerChallenges
export async function getChallenges(params = {}) {
    return get(PARTNER_CHALLENGES_URL, params).then((res) => res.data.data);
}

export async function getChallengeById(params = {}) {
    const { challengeId, includeTopContributors } = params;
    return get(`${CHALLENGE_URL}/${challengeId}`, {
        includeTopContributors,
    }).then((res) => res.data.data);
}

export async function getConnectedChallenges(params = {}) {
    return get(GET_PARTNER_CONNECTED_CHALLENGES_URL(params.challengeId), {
        limit: 100,
        skip: 0,
    }).then((res) => res.data.data);
}

export async function getChallengeCodes(params = {}) {
    return get(GET_CHALLENGE_CODES_URL(params.challengeId), {
        limit: 100,
        skip: 0,
    }).then((res) => res.data.data);
}

export async function getChallengeNotifications(params = {}) {
    return get(CHALLENGE_NOTIFICATION_URL, {
        contextKey: 'VIEW_CHALLENGE',
        contextValue: params.challengeId,
        limit: params.limit,
        skip: params.skip ? params.skip : 0,
    }).then((res) => res.data.data);
}

export async function createChallengeNotification(params = {}) {
    return post(CHALLENGE_NOTIFICATION_URL, {
        contextValue: params.challengeId,
        title: params.title,
        message: params.message,
    }).then((res) => res.data.data);
}

export async function createChallengecode(params = {}) {
    return post(NEW_CHALLENGE_CODE_URL, {
        challengeId: params.challengeId,
        code: params.code,
    }).then((res) => res.data.data);
}

export async function updateChallengeCode(params = {}) {
    return patch(
        UPDATE_CHALLENGE_CODE_URL(params.challengeId),
        {
            ...params.payload,
        },
        'data',
    ).then((res) => res.data.data);
}

export async function getTags(params = {}) {
    return get(TAGS_URL, params).then((res) => res.data.data);
}

export async function getUsers(params = {}) {
    return get(USERS_URL, params).then((res) => res.data.data);
}

export async function getReport(params = {}) {
    params = { ...params };
    return get(REPORTS_URL, params).then((res) => res.data);
}

export async function getPartnerCountries(params = {}) {
    params = { ...params };
    return get(PARTNER_COUNTRIES_URL, params).then((res) => res.data);
}

/**
 * Fetches all/Filtered litters from the API, to be shown on Map, List etc
 *
 * @param {object} params - can be any filtering paramters e.g. limit: 500
 */
export async function getLitters(params = {}) {
    return get(ALL_LITTERS_URL, params).then((res) => res.data);
}

export async function getPiecesCollected(params = {}) {
    params = { ...params };
    return get(PIECES_COLLECTED_URL, params).then((res) => res.data.data);
}

export async function getChallengeNames(params = {}) {
    return get(PARTNER_CHALLENGE_NAMES_URL, params).then(
        (res) => res.data.data,
    );
}

/**
 * Fetches all/Filtered challenges from the API
 *
 * @param {object} params - can be any filtering paramters e.g. global: true
 */
export async function getPartnerChallenges(params = {}) {
    return get(PARTNER_CHALLENGES_URL, params).then((res) => res.data.data);
}

export async function getParticipatedChallenges(params = {}) {
    return get(PARTICIPATED_CHALLENGES_URL, params).then(
        (res) => res.data.data,
    );
}

export async function getPartnerCampaigns(params = {}) {
    return get(PARTNER_CAMPAIGNS_URL, params).then((res) => res.data.data);
}

export async function getCampaignById(params = {}) {
    const { challengeId } = params;
    return get(`${PARTNER_CAMPAIGNS_URL}/${challengeId}`).then(
        (res) => res.data.data,
    );
}

export async function getCampaignChallenges(params = {}) {
    return get(GET_CAMPAIGN_CHALLENGES_URL(params.challengeId), {
        limit: 100,
        skip: 0,
    }).then((res) => res.data.data);
}

export async function updateChallengeStatus(params = {}) {
    return patch(
        `${PARTNER_CHALLENGE_URL}/${params.challengeId}/status`,
        params.params,
    ).then((res) => res.data.data);
}

export async function updateSegment(params = {}) {
    let { segmentId, notes } = params;
    return patch(UPDATE_SEGMENT_URL(segmentId), { notes }, 'data').then(
        (res) => res.data.data,
    );
}

export async function updateSegmentName(params = {}) {
    let { segmentId, name } = params;
    return patch(UPDATE_SEGMENT_URL(segmentId), { name }, 'data').then(
        (res) => res.data.data,
    );
}

export async function deleteSegment(params = {}) {
    let { segmentId } = params;
    return patch(
        UPDATE_SEGMENT_URL(segmentId),
        { isValid: false },
        'data',
    ).then((res) => res.data.data);
}

export async function getSegments(params = {}) {
    const { challengeId } = params;
    params = { limit: 10, ...params.params };
    return get(`${PARTNER_CHALLENGE_URL}/${challengeId}/segments`, params).then(
        (res) => res.data.data,
    );
}

export async function getUserSegments(params = {}) {
    const { userId, ...restParams } = params;
    return get(`${USER_SEGMENTS_URL}/${userId}/segments`, {
        limit: 20,
        ...restParams,
    }).then((res) => res.data.data);
}

export async function getSegmentTags(params = {}) {
    const { segmentId } = params;
    params = { limit: 10, ...params.params };
    return get(`${SEGMENT_TAGS_URL}/${segmentId}/tags`, params).then(
        (res) => res.data.data,
    );
}

export async function getChallengeLitters(params = {}) {
    const { challengeId } = params;
    params = { limit: 15000, ...params.params };
    return get(
        `${PARTNER_CHALLENGE_URL}/${challengeId}/litter-location`,
        params,
    ).then((res) => res.data.data);
}

/**
 * Is used to process payment via card
 *
 * @param {object} cardCreds - card token along with other meta data
 */
export async function processPayment(cardCreds = {}) {
    return post(RECURRING_CHARGE_URL, cardCreds).then((res) => res.data);
}

/**
 * @usage - Used to update normal contributor to paid contributor
 *
 * @param {object} body - any data required for the trasition of role
 */
export async function updateUserToPaidContributor(body = {}) {
    return post(ROLE_UPDATE_TO_PAID_CONTRIBUTOR_URL, body).then(
        (res) => res.data.data,
    );
}

/**
 * Switches users role to the requested one
 *
 * @param {int} roleId - roleId to switch the role to
 */
export async function switchUsersRole(roleId) {
    return post(SWITCH_USER_ROLE_URL, { roleId }).then((res) => res.data.data);
}

/**
 * Fetches list of challenges for analysis/segment-comparison
 */
export async function getAnalysisChalenges() {
    return get(ANALYSIS_CHALLENGES_URL).then((res) => res.data.data);
}

/**
 * Fetches list of researchers for analysis/segment-comparison
 */
export async function getAnalysisResearchers(params = {}) {
    return post(ANALYSIS_RESEARCHERS_URL, params).then((res) => res.data.data);
}

/**
 * Fetches list of segments for analysis/segment-comparison
 */
export async function getAnalysisSegments(params = {}) {
    return post(ANALYSIS_SEGMENTS_URL, params).then((res) => res.data.data);
}

/**
 * Fetches list of top tags based on taxonomy and activity Ids
 *
 * @param {string} taxonomy
 * @param {array} activityIds - ids of segments
 */
export async function getAnalysTopTags(params = {}) {
    return post(ANALYSIS_SUMMARY_TOP_TAGS_URL, params).then(
        (res) => res.data.data,
    );
}

/**
 * Fetches list of tags based on taxonomy and activity Ids
 *
 * @param {string} taxonomy
 * @param {array} activityIds - ids of segments
 */
export async function getAnalysSegmentTags(params = {}) {
    return post(ANALYSIS_SEGMENT_TAGS_URL, params).then((res) => res.data.data);
}

/**
 * Fetches list of litters to show on heatmap
 *
 * @param {array} activityIds - ids of segments
 * @param {timestamp} startDate - start date to limit litters from
 */
export async function getHeatmapLitters(params = {}) {
    return post(ANALYSIS_HEATMAP_LITTERS_URL, params).then(
        (res) => res.data.data,
    );
}

/**
 * Fetches index of segments based on activity Ids
 */
export async function getAnalysSegmentIndex(params = {}) {
    return get(ANALYSIS_SEGMENT_INDEX_URL, params).then((res) => res.data.data);
}

/*
 * Get User Resources
 */
export async function getResourcesAPI(params = {}) {
    return get(RESOURCES_URL, params).then((res) => res.data);
}

export async function getPartnerAdmins(partnerId) {
    return get(PARTNER_ADMINS_URL, partnerId).then((res) => res.data);
}

export async function getPartnerUsers(partnerId) {
    return get(PARTNER_USERS_URL, partnerId).then((res) => res.data);
}

export async function addPartnerUsers(body) {
    return post(PARTNER_USERS_URL, body).then((res) => res.data);
}

export async function createPartnerAdmin(body) {
    return post(PARTNER_ADMINS_URL, body).then((res) => res.data);
}
export async function deletePartnerAdmin(body) {
    return destroy(PARTNER_ADMINS_URL, body).then((res) => res.data);
}

export async function getCScientist(partnerId) {
    return get(PARTNER_CITIZEN_SCIENTIST_URL, partnerId).then(
        (res) => res.data,
    );
}

export async function addCScientist(body) {
    return post(PARTNER_CITIZEN_SCIENTIST_URL, body).then((res) => res.data);
}

export async function deleteCScientist(body) {
    return destroy(PARTNER_CITIZEN_SCIENTIST_URL, body).then((res) => res.data);
}

export async function deletePartnerInvite(body) {
    return destroy(PARTNER_INVITE_URL, body).then((res) => res.data);
}

export async function resendPartnerInvite(body) {
    return post(RESEND_PARTNER_INVITE_URL, body).then((res) => res.data);
}

export async function getChildPartners(params) {
    return get(PARTNER_CHILD_URL, params).then((res) => res.data);
}

export async function createChildPartner(body) {
    return post(PARTNER_CHILD_URL, body).then((res) => res.data);
}

export async function createPartner(body) {
    return post(BASE_PARTNER_URL_V6, body).then((res) => res.data);
}

export async function getPartnerProfile(params) {
    return get(BASE_PARTNER_URL_V6, params).then((res) => res.data);
}

/**
 * Fetches details of partner License
 */
export async function getPartnerLicense() {
    return get(PARTNER_LICENSE_URL).then((res) => res.data.data);
}

/**
 * Send Email with provided to,body,subject
 */
export async function sendEmail(body) {
    return post(EMAIL_URL, body).then((res) => res.data.data);
}

/**
 * Fetches details of litterCounts, newUsers created between provided dates
 */
export async function getMonitorDetail(params) {
    return get(MONITOR_URL, params).then((res) => res.data.data);
}

/**
 * Send Email with provided to,body,subject
 */
export async function changeUserRole(body) {
    return post(CHANGE_ROLE_URL, body).then((res) => res.data.data);
}

/**
 * Get authenticated user permissions
 */
export async function getUserPermissions() {
    return get(USER_PERMISSION_URL).then((res) => res.data.data);
}

export async function getSegmentImages(params) {
    return get(SEGMENT_IMAGES_URL, params).then((res) => res.data.data);
}

export async function getSegmentLitters(params) {
    const { activityId } = params;
    return get(SEGMENT_LITTERS_URL(activityId), {
        limit: params.limit,
        skip: params.skip,
    }).then((res) => res.data.data);
}

export async function createResearchProject(params) {
    return post(RESEARCH_PROJECTS_URL, params).then((res) => res.data.data);
}

export async function getResearchProjects(params) {
    return get(RESEARCH_PROJECTS_URL, params).then((res) => res.data.data);
}

export async function getResearchPlaces(params) {
    return get(RESEARCH_GET_PLACES_URL, params).then((res) => res.data.data);
}
export async function getPlaceDetail(placeId) {
    return get(`${RESEARCH_PLACE_DETAIL_URL}/${placeId}`).then(
        (res) => res.data,
    );
}

export async function editResearchPlace(params) {
    return patch(
        `${RESEARCH_EDIT_PLACE_URL}/${params.placeId}`,
        { name: params.name, lat: params.lat, long: params.long },
        'data',
    ).then((res) => res.data.data);
}

export async function unassignResearcher(params) {
    return post(RESEARCH_UNASSIGN_PLACE_URL, params).then(
        (res) => res.data.data,
    );
}

export async function deleteResearchPlace(params) {
    return destroy(`${RESEARCH_EDIT_PLACE_URL}/${params.placeId}`).then(
        (res) => res.data,
    );
}

export async function assignResearchPlaces(params) {
    return post(RESEARCH_ASSIGN_PLACES_URL, params).then(
        (res) => res.data.data,
    );
}

export async function createChallengeAPI(params) {
    switch (params.challengeType) {
        case 'local':
            return post(CREATE_LOCAL_CHALLENGE_URL, {
                ...params,
                challengeType: 'TIME_BASED',
            }).then((res) => res.data.data);
        case 'global':
            return post(CREATE_GLOBAL_CHALLENGE_URL, {
                ...params,
                challengeType: 'TIME_BASED',
            }).then((res) => res.data.data);
        case 'connected':
            return post(CREATE_FEATURED_CHALLENGE_URL, {
                ...params,
                challengeType: 'TIME_BASED',
            }).then((res) => res.data.data);
        default:
            throw 'Challenge type not sent';
    }
}

export async function updateChallengeAPI(params) {
    return patch(
        `${GET_FEATURED_CHALLENGES_URL}/${params.id}`,
        {
            ...params,
            challengeType: 'TIME_BASED',
        },
        'data',
    ).then((res) => res.data.data);
}

export async function featuredChallengesAPI(params) {
    if (params.search)
        return get(`${SEARCH_CHALLENGES_URL}`, {
            isGlobal: true,
            isPublished: true,
            q: params.search,
        }).then((res) => res.data.data);
    return get(`${GET_FEATURED_CHALLENGES_URL}`, {
        isGlobal: true,
        isPublished: true,
    }).then((res) => res.data.data);
}

export async function deleteInvitation() {}

export async function getUserImages(skip, limit) {
    const res = await get(USER_IMAGES_URL, { skip, limit });
    return res.data.data;
}

export async function getAllTaxonomy() {
    const res = await get(GET_ALL_TAXONOMY_URL);
    return res.data.data;
}

export async function updateTagByImageId(imageId, updateData) {
    const res = await patch(
        UPDATE_TAGS_BY_IMAGE_ID(imageId),
        updateData,
        'data',
    );
    return res.data.data;
}

export async function getProjectLocations(
    projectId,
    skip,
    limit,
    sortOrder,
    sortField,
    statuses,
    zoneIds,
    locationIds,
) {
    const queryParams = {};
    // pagination
    if (Number.isInteger(skip) && Number.isInteger(limit)) {
        queryParams.skip = skip;
        queryParams.limit = limit;
    }

    if (sortField && sortOrder) {
        queryParams.sortField = sortField;
        queryParams.sortOrder = sortOrder;
    }

    if (statuses && Array.isArray(statuses)) queryParams.statuses = statuses;
    if (zoneIds && Array.isArray(zoneIds)) queryParams.zoneIds = zoneIds;
    if (locationIds && Array.isArray(locationIds))
        queryParams.locationIds = locationIds;

    const res = await get(GET_PROJECT_LOCATIONS(projectId), queryParams);
    return res.data;
}

export async function getProjectZones(projectId) {
    const res = await get(GET_PROJECT_ZONES(projectId));
    return res.data.data;
}

export async function getLittersForManySegments(params = {}) {
    const res = await get(GET_LITTERS_FOR_MANY_SEGMENTS, params);
    return res.data.data;
}

export async function updateResearchTaskStatus(taskId, newStatus) {
    const res = await patch(
        UPDATE_RESEARCH_TASK_BY_ID(taskId),
        { status: newStatus },
        'data',
    );
    return res.data.data;
}

export async function updateResearchSegmentStatus(segmentId, newStatus) {
    const res = await patch(
        UPDATE_RESEARCH_SEGMENT_BY_ID(segmentId),
        { status: newStatus },
        'data',
    );
    return res.data.data;
}

export async function getResearchProjectById(projectId) {
    const res = await get(RESEARCH_PROJECT_BY_ID(projectId));
    return res.data.data;
}

export async function getAllResearchLocations(listNamesOnly) {
    const res = await get(RESEARCH_LOCATIONS, { listNamesOnly });
    return res.data.data;
}

export async function deleteImage(imageId) {
    return destroy(RESEARCH_ANALYZE_IMAGE_BY_ID(imageId)).then(
        (res) => res.data,
    );
}
